export default __webpack_public_path__ + "static/media/Refund_Policy.ca36dca6.pdf";